import React, {
  Component,
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";
import { Icon, Loader } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

import swal from "sweetalert";
import {
  Container,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  LinkRedirect,
  SemanticButton,
  StatusToogleButton,
} from "./styled";

import { producaov2 as api } from "../../../../services/apis";

export const ValueList = (props) => {
  const [depoimento, setDepoimento] = useState(props.valor);
  const [ativo, setAtivo] = useState(props.valor.ativo);

  const valorButton = () => {
    if (ativo == "S") {
      return "Ativo";
    } else {
      return "Inativo";
    }
  };

  const valorArea = () => {
    if (depoimento.area == null) {
      return "area não salva";
    } else {
      return depoimento.area.nome;
    }
  };

  const valorTreinamento = () => {
    if (depoimento.treinamento == null) {
      return "treinamento não salvo";
    } else {
      return depoimento.treinamento.nome;
    }
  };

  const ativoValue = useCallback(() => {
    const newAtivo = ativo === "S" ? "N" : "S";

    api
      .put(`admin/pessoa/depoimentos/${depoimento.id}`, {
        ativo: newAtivo,
      })
      .then(() => {
        setAtivo(newAtivo);
      })
      .catch((err) => {
        console.error(err);
        swal("Ops!", "Ocorreu um erro ao atualizar status", "error");
      });
  }, [ativo]);

  return (
    <SemanticTable.Row>
      <SemanticTable.Cell style={{ width: "8%" }}>
        {" "}
        {depoimento.id}
      </SemanticTable.Cell>
      <SemanticTable.Cell style={{ width: "15%" }}>
        {depoimento.aluno}
      </SemanticTable.Cell>
      <SemanticTable.Cell style={{ width: "15%" }}>
        {valorArea()}
      </SemanticTable.Cell>
      <SemanticTable.Cell>{valorTreinamento()}</SemanticTable.Cell>
      <SemanticTable.Cell style={{ width: "10%" }}>
        <StatusToogleButton ativo={ativo === "S"} onClick={ativoValue}>
          {valorButton()}
        </StatusToogleButton>
      </SemanticTable.Cell>
      <SemanticTable.Cell style={{ width: "10%" }}>
        <>
          <Link to={`/admin/depoimentosdev/detalhes/${depoimento.id}`}>
            <SemanticButton icon="edit icon" info="edit" />
          </Link>

          <SemanticButton
            icon="trash icon"
            info="delete"
            onClick={(e) => props.deletarDepoimento(depoimento.id)}
          />
        </>
      </SemanticTable.Cell>
    </SemanticTable.Row>
  );
};
